import { IAlertNotificationList } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export const useGetAlerts = () => {
    const { current: session } = useContext(SessionContext);

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useQuery<IAlertNotificationList | null, Error>({
        queryKey: ['alerts', userUuid, tenantId],
        queryFn: async () => {
            if (!session?.context) {
                throw new Error('Session context not available');
            }
            const response = await fetch(`${session.context.url}/alerts/list/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...session.context.headers,
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch alerts: ${response.statusText}`);
            }
            return response.json();
        },
        enabled: !!userUuid && !!tenantId && !!session?.context,
        refetchInterval: 5 * 60 * 1000, // 5 min
        staleTime: 5 * 60 * 1000, // 5 min
    });
}